const remuneration = 'EmploymentEquity/Remuneration';

export const GetTotalRemuneration = `${remuneration}/TotalRemuneration`;
export const GetRemuneration = `${remuneration}/Remuneration`;
export const GetTotalRemunerationIndividuals = `${remuneration}/TotalRemunerationIndividuals`;
export const GetRemunerationIndividuals = `${remuneration}/RemunerationIndividuals`;
